import React, { useMemo, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
} from 'core'
import { connect } from 'react-redux'
import {
  getCoopMisoMapping,
  postCoopMisoMapping,
  deleteCoopMisoMapping,
} from './misoApi'
import CommonScreen from '../admin/component/CommonScreen'
import { Input, Button } from 'antd'
import styled from 'styled-components'
import UtilityUnitSelection from '../core/component/UtilityUnitSelection'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

const TableTD = styled.td`
  text-align: end;
`
const headers = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'equipmentName',
    display: 'Requested Equipment Name',
    isFiltered: true,
    isRequired: true,
    width: 300,
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const CoopMisoMapping = ({ unitNameMap, utilityNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) =>
                `${value} - ${utilityNameMap[value]}` || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value, rowData }) =>
                `${rowData.unit} - ${unitNameMap[value]}` || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Select Utility/Unit : </TableTD>
            <UtilityUnitSelection
              utility={insertData.utility}
              unit={insertData.unitId}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unit: value[1].substr(3),
                  unitId: value[1],
                })
              }}
              casStyle={{ marginLeft: '5px' }}
            />
          </tr>
          <tr>
            <TableTD>Equipment Name :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                style={{ width: '90%', marginLeft: '5px' }}
                key="equipmentName"
                value={insertData.equipmentName}
                placeholder="Equipment Name"
                name="equipmentName"
                onChange={e =>
                  setInsertData({
                    ...insertData,
                    equipmentName: e.target.value,
                  })
                }
              />
            </td>

            <td colSpan={3} style={{ paddingLeft: '16px' }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                <Button type="primary" onClick={() => onAdd(true)}>
                  Add
                </Button>
                <Button type="primary" onClick={() => onAdd(false)}>
                  Add & Hide
                </Button>
                <Button type="danger" onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title="MISO Mapping"
      header={headerWithFormatter}
      saveTask={postCoopMisoMapping}
      retrieveTask={getCoopMisoMapping}
      deleteTask={deleteCoopMisoMapping}
      altBy={d => d.equipmentName}
      autoRetrieve
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(CoopMisoMapping)
